"use strict";
import pointInPolygon from "../../util/point_in_polygon";
import AnnotationComponents from "./components";
import DragPoint from "./drag_point";
export function isPointIn(p, polygon) {
  return pointInPolygon([p.x, p.y], polygon);
}
export const hoverFor = (mousePos) => (typeID, dragPoints) => {
  const Comp = AnnotationComponents[typeID];
  const hoveredDragPointIndex = dragPoints.findIndex(
    DragPoint.isPointIn(mousePos)
  );
  const isIndex = typeof hoveredDragPointIndex === "number" && hoveredDragPointIndex >= 0;
  return {
    hovered: isPointIn(mousePos, Comp.getBoundingBox(dragPoints)) || isIndex,
    dragPointIndex: isIndex ? hoveredDragPointIndex : false
  };
};
